import {
  computed,
  MaybeRefOrGetter,
  onScopeDispose,
  reactive,
  toValue,
  watchEffect,
} from "vue";
import { createGlobalState } from "@vueuse/core";

const useHiders = createGlobalState(() => reactive(new Set<symbol>()));

export function useHideFeedbackSurvey(when: MaybeRefOrGetter<boolean> = true) {
  const hiders = useHiders();
  const token = Symbol("hideFeedbackSurvey");
  watchEffect(() => {
    if (toValue(when)) hiders.add(token);
    else hiders.delete(token);
  });
  onScopeDispose(() => hiders.delete(token));
}

export function useFeedbackSurveyHidden() {
  const hiders = useHiders();
  return computed(() => hiders.size > 0);
}
